<div *ngIf="errors!.length > 0" class="alert alert-danger">
  <p>Please fix the following errors:</p>
  <ul>
    <li *ngFor="let error of errors">{{ error }}</li>
  </ul>
</div>